import React, { createContext, useContext } from 'react';

const SmartFitnessBandContext = createContext(undefined);

export const SmartFitnessBandProvider = ({ children, value }) => {
    return <SmartFitnessBandContext.Provider value={value}>{children}</SmartFitnessBandContext.Provider>;
};

export const useSmartFitnessBandContext = () => {
    const context = useContext(SmartFitnessBandContext);
    if (context === undefined) {
        throw new Error('useSmartFitnessBandContext 必須在 SmartFitnessBandProvider 中使用');
    }
    return context;
};